import { Badge, Group, UnstyledButton } from '@mantine/core';
import React from 'react';

export type LanguageChip = {
    value: string;
    label: string;
    /** has content / reviewed / dirty indicator */
    mark?: 'filled' | 'reviewed' | 'dirty' | 'empty';
};

const markColor: Record<NonNullable<LanguageChip['mark']>, string> = {
    filled: 'blue',
    reviewed: 'green',
    dirty: 'orange',
    empty: 'gray',
};

export const LanguageChips = ({
    languages,
    value,
    onChange,
}: {
    languages: LanguageChip[];
    value: string;
    onChange: (lang: string) => void;
}) => (
    <Group gap={6} wrap='wrap'>
        {languages.map((lang) => {
            const active = lang.value === value;
            const mark = lang.mark || 'empty';

            return (
                <UnstyledButton key={lang.value} onClick={() => onChange(lang.value)}>
                    <Badge
                        size='lg'
                        variant={active ? 'filled' : 'light'}
                        color={active ? 'blue' : markColor[mark]}
                        style={{ cursor: 'pointer' }}
                    >
                        {lang.label}
                        {mark === 'reviewed' ? ' ✓' : mark === 'dirty' ? ' •' : ''}
                    </Badge>
                </UnstyledButton>
            );
        })}
    </Group>
);
